import { Nullable } from '@types'

import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import RadioGroup from '@mui/material/RadioGroup'
import { SelectChangeEvent } from '@mui/material/Select'
import Typography from '@mui/material/Typography'
import { numberWithCommas } from '@shared/utils'

import { SelectFormControlLabel, SelectLabelText, SelectLabelWrapper, SelectRadio } from '../../index.styles'

interface Props {
  value: Nullable<string>
  label: string
  options: { label: string; total: string; value: Nullable<string>; forceChecked?: boolean }[]
  onChange: (value: string) => void
}

const SingleSelect = (props: Props) => {
  const { value: selectedValue, label, options, onChange } = props

  const handleChange = (e: SelectChangeEvent) => {
    const target = e.target as HTMLInputElement

    onChange(target.value)
  }

  const forceSelectedItem = { value: null } // options.find(i => i.forceChecked)

  return (
    <FormControl fullWidth data-testid="single_select">
      <FormLabel>{label}</FormLabel>
      <RadioGroup
        name={label}
        value={selectedValue === null ? null : forceSelectedItem?.value || selectedValue}
        onChange={handleChange}
        defaultChecked
      >
        {options.map(i => (
          <SelectFormControlLabel
            key={i.value}
            value={i.value}
            control={<SelectRadio disableRipple />}
            label={
              <SelectLabelWrapper>
                <SelectLabelText variant="body2" data-testid="single_select_label">
                  {i.label}
                </SelectLabelText>
                {!!i.total && (
                  <Typography variant="body2" data-testid="single_select_total">
                    ({numberWithCommas(i.total)})
                  </Typography>
                )}
              </SelectLabelWrapper>
            }
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}

export default SingleSelect
